import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-no-report-pack',
  templateUrl: './no-report-pack.component.html',
  styleUrls: ['./no-report-pack.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class NoReportPackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
